import {
	Avatar,
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from "@exopengithub/exokit";
import { useTranslation } from "react-i18next";

interface UserIdentitySummaryProps {
	avatarSrc: string;
	name: string;
	email: string;
	// Only meaningful for a person's own profile — an admin looking at a
	// company member can't change that other person's picture.
	avatarHref?: string | undefined;
}

// Read-only "who is this" block — shared between a person's own profile page
// and an admin's view of a company member, where name/email are never
// editable (they come from the identity provider, not from either screen).
export const UserIdentitySummary = ({
	avatarSrc,
	name,
	email,
	avatarHref,
}: UserIdentitySummaryProps) => {
	const { t } = useTranslation();
	const avatar = <Avatar src={avatarSrc} size="lg" alt="" />;

	return (
		<div className="flex items-center gap-4">
			{avatarHref ? (
				<Tooltip>
					<TooltipTrigger asChild>
						<a href={avatarHref} target="_blank" rel="noopener noreferrer">
							{avatar}
						</a>
					</TooltipTrigger>
					<TooltipContent>{t("Edit")}</TooltipContent>
				</Tooltip>
			) : (
				avatar
			)}
			<div>
				<div className="font-medium text-gray-900">{name}</div>
				<div className="text-gray-500 text-sm">{email}</div>
			</div>
		</div>
	);
};
